import { TextField } from '@fluentui/react';
import React from 'react';
import { FilterArrayType, FilterCombineType, FilterProps } from '.';

export type TextSearchFilterProps = FilterProps & {
  placeholder?: string;
  onOptionChange?: (data: FilterArrayType) => void;
  disabled?: boolean;
  selectedKey?: number | string | undefined;
  defaultFilter?: boolean;
  value?: string | undefined;
  combineType?: FilterCombineType;
  isNumeric?: boolean;
};

export const TextSearchFilter: React.FC<TextSearchFilterProps> = ({
  placeholder = 'Select item',
  defaultFilter = false,
  onOptionChange,
  filterKey,
  disabled = false,
  value,
  combineType = FilterCombineType.AND,
  isNumeric = false,
}) => {
  const label = defaultFilter ? placeholder : undefined;
  const placeholderContent = defaultFilter ? 'Search' : placeholder;
  const isValidNumeric = (value: any) => /^[0-9]+$/.test(value);
  return (
    <TextField
      disabled={disabled}
      placeholder={placeholderContent}
      label={label}
      value={value}
      onChange={(_event, value) => {
        const validInput = isNumeric ? isValidNumeric(value) : true;
        const input = validInput ? value : '';
        onOptionChange?.({
          value: input || '',
          filterKey,
          label: input || '',
          combineType,
        });
      }}
    />
  );
};
